import { Form, NumberBox, SelectBox, TextBox } from 'devextreme-react';
import { ButtonItem, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import { apiGetP, apiPostP } from '../../GanjiTools';
import { UniGrid } from '../UniGrid';
import ExportTool from './ExportTool';
import SideDivider from '../layout/SideDivider';
import CollapsibleBox from '../utils/CollapsibleBox';
import { style } from 'typestyle';
import Theme from '../theme/Theme';

class ShareHolderReports extends Component {
    state = {
        shareHolder: this.props.shareHolder,
        //shareHoldersLookup: window.shareHoldersLookup ?? [],
        loading: true,
    }

    static fetchShareHoldersLookupP(forceReload) {
        return new Promise((resolve, reject) => {
            if (!forceReload && window.shareHoldersLookup?.length > 0) {
                resolve?.(window.shareHoldersLookup);
                return;
            }
            apiPostP('/api/dyna/rowsAsLookup/shareHolder', {})
                .then(res => {
                    let { list, error } = res ?? { error: 'No response' };
                    if (error?.length > 0) {
                        reject?.(error);
                        return;
                    }
                    window.shareHoldersLookup = list;
                    resolve?.(list);
                    console.log('shareHoldersLookup=', shareHoldersLookup);
                }).catch(reject)
        });
    }

    loadShareHolderReport = id => {
        apiGetP(`/api/tarabar/report/shareHolder/${id}`)
            .then(res => {
                let { error, ins, outs } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ totalMoneyIn: ins, totalMoneyOut: outs, moneyBalance: ins - outs })
            })
            .catch(window.notif);

        return undefined;
    }

    onSelectedShareHolderChanged = id => {
        let { totalMoneyIn, totalMoneyout } = this.loadShareHolderReport(id) ?? {};
        this.setState({ totalMoneyIn, totalMoneyout, shareHolder: window.shareHoldersLookup.find(x => x.id === id) });
    }

    componentDidMount() {
        ShareHolderReports.fetchShareHoldersLookupP(true)
            .then(_ => this.setState({ loading: false }))
            .catch(console.log);
        //.then(shareHoldersLookup => this.setState({ shareHoldersLookup }));
    }

    render() {
        if (this.state.loading)
            return (
                <p style={{ padding: '3rem' }}> صبر کنید...</p>
            );

        let title = 'نمایش سوابق', summary = '', width = this.props.width ?? `${SideDivider.bodyWidth - 150}px`;

        return (
            <div style={{ padding: '0 3rem' }}>
                <CollapsibleBox className={'loadorder-collapsibleboxd ' +
                    style({
                        background: Theme.col1('whitesmoke'),
                        borderRadius: '1rem',
                        color: Theme.col0()
                    })
                }
                    style={{ width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}

                    title={
                        <div className='loadorder-title'
                            style={{
                                height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                                justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                            }}
                        >
                            <span style={{ fontWeight: '900' }}>{title}</span>
                        </div>
                    }
                    headerStyle={{
                        width: `calc(${width} - ${this.props.wizardMode ? -2 : 2}rem)`,
                        background: Theme.col1('whitesmoke'),
                        color: Theme.col0(),
                    }}
                    summary={
                        <span className='loadorder-summary'
                            style={{
                                margin: '0 1rem',
                                fontSize: '0.8rem',
                                color: Theme.col2('#550')
                            }}
                        >
                            {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                        </span>
                    }

                    bodyStyle={{
                        ...this.props.style, ...this.stl, marginTop: '0',
                        borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                        width: `calc(${width} - 2rem)`,
                        background: Theme.col1('whitesmoke'),
                    }}
                >
                    <Form rtlEnabled colCount={60} width={`calc(${width} - 3rem)`} //key={'shrhldform_' + (window.shareHoldersLookup?.length)}
                    >
                        <SimpleItem colSpan={60} label={{ text: 'انتخاب سهامدار' }}
                        //key={'shrhldlkp_' + (window.shareHoldersLookup?.length)}
                        >
                            <SelectBox rtlEnabled items={window.shareHoldersLookup} valueExpr='id' displayExpr='summary'
                                value={this.state.shareHolder?.id}
                                onValueChanged={e => this.onSelectedShareHolderChanged(e.value)}
                            />
                        </SimpleItem>
                        <SimpleItem colSpan={60}>
                            <UniGrid table='MoneyInOut' field='fK_ShareHolder' equalTo={this.state.shareHolder?.id} readOnly noMetaGrid
                                hideFields={['fK_ShareHolder']}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع واریزی ها' }} colSpan={30}>
                            <NumberBox readOnly key={'nbi_' + this.state.totalMoneyIn}
                                value={this.state.totalMoneyIn ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع برداشت ها' }} colSpan={30}>
                            <NumberBox readOnly key={'nbo_' + this.state.totalMoneyOut}
                                value={this.state.totalMoneyOut ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'تراز مالی' }} colSpan={60}>
                            <NumberBox readOnly
                                value={this.state.moneyBalance ?? 0}
                            />
                        </SimpleItem>
                    </Form>
                </CollapsibleBox>

                <div style={{ margin: '2rem 0 1rem 0', color: 'gray' }}>
                </div>

                <ExportTool table='moneyInOut' width={width} excludeFields={['fK_shareHolder']}
                    extraFieldEqualities={{ name: 'fK_shareHolder', oper: '=', value1: this.state.shareHolder?.id, nature: 'number' }}
                />
            </div>
        );
    }
}

export default ShareHolderReports;